import { createAppModal } from 'utils/modal';

import { OAuthProviderModalCreate } from './views/create/oauthProviderModalCreate.view';
import { OAuthProviderModalUpdate } from './views/update/oauthProviderModalUpdate.view';

/**
 * A modal for configuring OAuth providers. This is a wrapper that provides the
 * GraphQL client inside the modal implementation to support queries and
 * mutations against the partners-api-gateway.
 */
export const OAuthProviderConfigurationModal = createAppModal(
  { type: 'app:oauthProviderConfiguration' },
  ({ isOpen, modal, hide, meta }): JSX.Element => {
    return modal.arg.mode === 'create' ? (
      <OAuthProviderModalCreate isOpen={isOpen} meta={meta} hide={hide} />
    ) : (
      <OAuthProviderModalUpdate
        isOpen={isOpen}
        providerId={modal.arg.id || ''}
        meta={meta}
        hide={hide}
      />
    );
  },
);
